<mat-form-field appearance="fill">
    <mat-label>{{ label }}</mat-label>
    <mat-select [formControl]="accountSelectorTypeOptionsCtrl" (opened)="markAsTouched()">
        <mat-option
            *ngFor="let type of accountSelectorTypeOptions$ | async"
            [value]="type"
        >
            {{ type.label }}
        </mat-option>
    </mat-select>
</mat-form-field>
<mat-form-field
    appearance="fill"
    *ngIf="
        accountSelectorTypeOptionsCtrl.value.value !== 'accountNumber' &&
        !accountSelectorTypeOptionsCtrl.value.tagBased
    "
>
    <mat-label>{{ accountSelectorTypeOptionsCtrl.value.label }}s</mat-label>
    <mat-select
        panelClass="mat-select-search"
        [compareWith]="compareAccountFn"
        [formControl]="optionsCtrl"
        (opened)="optionsSearchInput.focus(); markAsTouched()"
        (closed)="accountSearchCtrl.reset()"
        [sbTestSelector]="sbTestSelector"
        omitInnerText="true"
        #accountSelect
        multiple
    >
        <mat-select-trigger *ngIf="options$ | async as options">
            <ng-container [ngSwitch]="optionsCtrl.value?.length > 1">
                <ng-container *ngSwitchCase="true">
                    <ng-container *ngIf="optionsCtrl.value?.length === options.length">
                        All
                    </ng-container>
                    <ng-container *ngIf="optionsCtrl.value?.length !== options.length">
                        {{ optionsCtrl.value?.length }} of {{ options.length }} selected
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="false">
                    <ng-container *ngIf="optionsCtrl.value?.length === 1">
                        {{
                            optionsCtrl.value[0][
                                accountSelectorTypeOptionsCtrl.value.value
                            ]
                        }}
                    </ng-container>
                    <ng-container *ngIf="optionsCtrl.value?.length === 0">
                        All
                    </ng-container>
                </ng-container>
            </ng-container>
        </mat-select-trigger>
        <header>
            <mat-form-field>
                <input
                    #optionsSearchInput
                    matInput
                    placeholder="Type to search"
                    type="text"
                    autocomplete="off"
                    (keydown.space)="$event.stopPropagation()"
                    [formControl]="optionSearchCtrl"
                />
            </mat-form-field>
            <mat-checkbox
                *ngIf="options$ | async as options"
                class="w-100 mat-option"
                [checked]="options.length === optionsCtrl.value?.length"
                [indeterminate]="
                    options.length !== optionsCtrl.value?.length &&
                    optionsCtrl.value?.length > 0
                "
                (change)="toggleOptions($event.checked, options)"
            >
                All
            </mat-checkbox>
        </header>
        <main>
            <ng-container *ngIf="options$ | async as options; let i = index">
                <mat-option
                    *ngFor="let option of options"
                    [value]="option"
                    [sbTestSelector]="sbTestSelector"
                    [sbTestIndex]="i"
                    omitInnerText="true"
                >
                    <div class="w-100">
                        <span class="text-truncate font-weight-bold">
                            {{
                                option[accountSelectorTypeOptionsCtrl.value.value] ||
                                    'n/a'
                            }}
                        </span>
                    </div>
                </mat-option>
                <div
                    *ngIf="!options.length"
                    class="pt-0 px-2 pb-2"
                    style="pointer-events: none"
                    [sbTestSelector]="sbTestSelector"
                    [sbTestIndex]="0"
                    omitInnerText="true"
                >
                    <div role="alert" class="info mt-0">
                        No
                        {{ accountSelectorTypeOptionsCtrl.value.label | lowercase }}
                        matched your search.
                    </div>
                </div>
            </ng-container>
        </main>
    </mat-select>
    <mat-hint [align]="accountSelect.panelOpen ? 'end' : 'start'">
        Select {{ accountSelectorTypeOptionsCtrl.value.label | lowercase }}(s)
    </mat-hint>
    <mat-error>
        <ng-container *ngIf="accountCtrl.hasError('required')">
            Select {{ accountSelectorTypeOptionsCtrl.value.label | lowercase }}(s)
        </ng-container>
    </mat-error>
</mat-form-field>
<mat-form-field appearance="fill" *ngIf="!accountSelectorTypeOptionsCtrl.value.tagBased">
    <mat-label>Account(s)</mat-label>
    <mat-select
        panelClass="mat-select-search"
        [compareWith]="compareAccountFn"
        [formControl]="accountCtrl"
        (opened)="searchInput.focus(); markAsTouched()"
        (closed)="accountSearchCtrl.reset()"
        [sbTestSelector]="sbTestSelector"
        omitInnerText="true"
        #accountSelect
        multiple
    >
        <mat-select-trigger *ngIf="accounts$ | async as options">
            <ng-container [ngSwitch]="accountCtrl?.value?.length > 0">
                <ng-container *ngSwitchCase="true">
                    <ng-container *ngIf="accountCtrl?.value?.length === options.length">
                        All
                        <ng-container
                            *ngIf="
                                !(
                                    optionsCtrl.value?.length === 0 ||
                                    optionsCtrl.value?.length ===
                                        (options$ | async)?.length
                                )
                            "
                        >
                            <ng-container *ngIf="optionsCtrl.value?.length > 1">
                                for
                                {{
                                    accountSelectorTypeOptionsCtrl.value.label
                                        | lowercase
                                }}s
                            </ng-container>
                            <ng-container *ngIf="optionsCtrl.value?.length === 1">
                                for
                                {{
                                    accountSelectorTypeOptionsCtrl.value.label | lowercase
                                }}
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="accountCtrl.value.length !== options.length">
                        {{ accountCtrl.value.length }} of {{ options.length }} selected
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="false">
                    <ng-container *ngIf="accountCtrl.value.length === 1">
                        {{ accountCtrl.value[0] }}
                    </ng-container>
                    <ng-container *ngIf="accountCtrl.value.length === 0">
                        All
                    </ng-container>
                </ng-container>
            </ng-container>
        </mat-select-trigger>
        <header>
            <mat-form-field>
                <input
                    #searchInput
                    matInput
                    placeholder="Type to search"
                    type="text"
                    autocomplete="off"
                    (keydown.space)="$event.stopPropagation()"
                    [formControl]="accountSearchCtrl"
                />
            </mat-form-field>
            <mat-checkbox
                *ngIf="filteredAccounts$ | async as accounts"
                class="w-100 mat-option"
                [checked]="(accounts$ | async).length === accountCtrl.value?.length"
                [indeterminate]="
                    (accounts$ | async).length !== accountCtrl.value?.length &&
                    accountCtrl.value?.length > 0
                "
                (change)="toggleAccounts($event.checked, accounts)"
            >
                All
            </mat-checkbox>
        </header>
        <main>
            <ng-container *ngIf="filteredAccounts$ | async as accounts; let i = index">
                <mat-option
                    *ngFor="let account of accounts"
                    [value]="valueKey ? account[valueKey] : account"
                    [sbTestSelector]="sbTestSelector"
                    [sbTestIndex]="i"
                    omitInnerText="true"
                >
                    <div class="w-100">
                        <span class="text-truncate font-weight-bold">
                            {{ account.accountClientAlias }}
                        </span>
                        <small
                            class="d-flex text-secondary justify-content-between align-items-center"
                        >
                            <span *ngIf="account.accountIssuerShortName">
                                {{ account.accountIssuerShortName }}
                            </span>
                            <span *ngIf="account.accountNumber">
                                {{ account.accountNumber }}
                            </span>
                        </small>
                    </div>
                </mat-option>
                <div
                    *ngIf="!accounts.length"
                    class="pt-0 px-2 pb-2"
                    style="pointer-events: none"
                    [sbTestSelector]="sbTestSelector"
                    [sbTestIndex]="0"
                    omitInnerText="true"
                >
                    <div role="alert" class="info mt-0">
                        No account matched your search.
                    </div>
                </div>
            </ng-container>
        </main>
    </mat-select>
    <mat-hint [align]="accountSelect.panelOpen ? 'end' : 'start'">
        Select account(s)
    </mat-hint>
    <mat-error>
        <ng-container *ngIf="accountCtrl.hasError('required')">
            Select account(s)
        </ng-container>
    </mat-error>
</mat-form-field>
<mat-form-field appearance="fill" *ngIf="accountSelectorTypeOptionsCtrl.value.tagBased">
    <mat-label>{{ accountSelectorTypeOptionsCtrl.value.label }}</mat-label>
    <mat-select
        panelClass="mat-select-search"
        [compareWith]="compareAccountFn"
        [formControl]="tagCtrl"
        (opened)="searchInput.focus(); markAsTouched()"
        (closed)="tagSearchCtrl.reset()"
        [sbTestSelector]="sbTestSelector"
        omitInnerText="true"
        #accountSelect
        multiple
    >
        <mat-select-trigger *ngIf="tagOptions$ | async as options">
            <ng-container [ngSwitch]="tagCtrl.value?.length > 0">
                <ng-container *ngSwitchCase="true">
                    <ng-container *ngIf="tagCtrl.value?.length === options.length">
                        All
                    </ng-container>
                    <ng-container *ngIf="tagCtrl.value?.length !== options.length">
                        {{ tagCtrl.value.length }} of {{ options.length }} selected
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="false">
                    <ng-container *ngIf="tagCtrl.value?.length === 1">
                        {{ tagCtrl.value[0] }}
                    </ng-container>
                    <ng-container *ngIf="tagCtrl.value?.length === 0">All</ng-container>
                </ng-container>
            </ng-container>
        </mat-select-trigger>
        <header>
            <mat-form-field>
                <input
                    #searchInput
                    matInput
                    placeholder="Type to search"
                    type="text"
                    autocomplete="off"
                    (keydown.space)="$event.stopPropagation()"
                    [formControl]="tagSearchCtrl"
                />
            </mat-form-field>
            <mat-checkbox
                *ngIf="tagOptions$ | async as tagOptions"
                class="w-100 mat-option"
                [checked]="(tagOptions$ | async).length === tagCtrl.value?.length"
                [indeterminate]="
                    (tagOptions$ | async).length !== tagCtrl.value?.length &&
                    tagCtrl.value?.length > 0
                "
                (change)="toggleTags($event.checked, tagOptions)"
            >
                All
            </mat-checkbox>
        </header>
        <main>
            <ng-container
                *ngIf="filteredTagOptions$ | async as tagOptions; let i = index"
            >
                <mat-option
                    *ngFor="let tagOption of tagOptions"
                    [value]="tagOption"
                    [sbTestSelector]="sbTestSelector"
                    [sbTestIndex]="i"
                    omitInnerText="true"
                >
                    <div class="w-100">
                        <span class="text-truncate font-weight-bold">
                            {{ tagOption.label }}
                        </span>
                        <small
                            class="d-flex text-secondary justify-content-between align-items-center"
                        >
                            <span *ngIf="tagOption.description">
                                {{ tagOption.description }}
                            </span>
                        </small>
                    </div>
                </mat-option>
                <div
                    *ngIf="!tagOptions.length"
                    class="pt-0 px-2 pb-2"
                    style="pointer-events: none"
                    [sbTestSelector]="sbTestSelector"
                    [sbTestIndex]="0"
                    omitInnerText="true"
                >
                    <div role="alert" class="info mt-0">
                        No
                        {{ accountSelectorTypeOptionsCtrl.value.label | lowercase }}
                        matched your search.
                    </div>
                </div>
            </ng-container>
        </main>
    </mat-select>
    <mat-hint [align]="accountSelect.panelOpen ? 'end' : 'start'">
        Select {{ accountSelectorTypeOptionsCtrl.value.label | lowercase }}
    </mat-hint>
    <mat-error>
        <ng-container *ngIf="accountCtrl.hasError('required')">
            Select {{ accountSelectorTypeOptionsCtrl.value.label | lowercase }}
        </ng-container>
    </mat-error>
</mat-form-field>
